import { render, staticRenderFns } from "./NpcManager.vue?vue&type=template&id=28c8b27c&scoped=true"
import script from "./NpcManager.vue?vue&type=script&lang=js"
export * from "./NpcManager.vue?vue&type=script&lang=js"
import style0 from "./NpcManager.vue?vue&type=style&index=0&id=28c8b27c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8b27c",
  null
  
)

export default component.exports